import Vue from 'vue';
import Router from 'vue-router';

const SaverbotAccountView = () => import('@/views/SaverbotAccountView.vue');
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/:externalId',
      name: 'saverbotAccount',
      component: SaverbotAccountView,
      beforeEnter: (to, from, next) => {
        if (!to.params.externalId) {
          next('/');
          return;
        }
        next();
      },
    },
    // {
    //   path: '*',
    //   redirect: '/',
    // },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 75 },
      };
    }
    return {
      x: 0,
      y: 0,
    };
  },
});
